class SignedDocument {
    documentUrl;
    signedAt;
    constructor(data) {
        this.documentUrl = data.documentUrl;
        this.signedAt = data.signedAt;
    }
}
export default SignedDocument;
